import { AZURE_DEVOPS_SDK } from '@/utils/azure-devops-helpers/general'

export const getAzureService = async (serviceName = '') => {
  if (!AZURE_DEVOPS_SDK) return null

  if (!serviceName) {
    throw new Error('Azure service name is required and must be valid')
  }

  return await AZURE_DEVOPS_SDK.getService(serviceName)
}
